// What the sandbox shows where a page would change something (D64, D105): the reason. Apps,
// keys, members and settings live in the person's own projects.
import { Link } from '@tanstack/react-router'
import { useI18n } from '../i18n'

export function SandboxReadOnly() {
  const { t } = useI18n()
  return (
    <main id="main">
      <div className="head-text">
        <div className="k">{t('sandbox.kicker')}</div>
        <h1 className="h1">{t('sandbox.readOnly.title')}</h1>
        <p className="lede">{t('sandbox.readOnly.body')}</p>
      </div>
      <Link className="btn solid" to="/" style={{ justifySelf: 'start' }}>
        {t('sandbox.back')}
      </Link>
    </main>
  )
}
